import { formatDistanceToNow, parseISO } from "date-fns";
import { UserIdentity } from "react-admin";

/**
 * Extract user ID from React Admin identity object
 */
export const getUserId = (identity: UserIdentity | undefined): string | undefined => {
  return identity?.id || identity?.user_id || identity?.sub || identity?.aegleId;
};

/**
 * Format date as relative time (e.g., "2 hours ago")
 */
export const formatCommentDate = (dateString: string): string => {
  try {
    const date = parseISO(dateString);
    if (isNaN(date.getTime())) {
      return "Just now";
    }
    const formatted = formatDistanceToNow(date, {
      addSuffix: true,
      includeSeconds: true,
    }).replace(/^about\s+/i, ""); // drop the noisy "about " prefix ("about 2 hours ago" -> "2 hours ago")
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  } catch {
    return "Just now";
  }
};
